import { useState } from 'react'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import Fade from '@mui/material/Fade'
import { useTranslation } from 'react-i18next'

const Content = styled('div')(({ theme: { spacing } }) => ({
  display: 'flex',
  padding: spacing(4, 3, 0, 3),
  alignItems: 'center',
  flexDirection: 'column',
  flex: 1
}))

const Circle = styled('div')(({ theme: { spacing } }) => ({
  display: 'flex',
  width: '141px',
  height: '141px',
  backgroundColor: '#EBF8FF',
  borderRadius: '100px',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: spacing(5),
  marginTop: spacing(4)
}))

const TextContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center'
}))

const RequestForProposalFeedbackSuccessState = () => {
  const [transition, setTransition] = useState<boolean>(true)
  const { t } = useTranslation()

  setTimeout(() => {
    setTransition(false)
  }, 3000)

  return (
    <Fade in={transition} {...(transition ? { timeout: 500 } : { timeout: 500 })}>
      <Content>
        <Circle>
          <CheckCircleOutlineIcon color="primary" sx={{ fontSize: '120px' }} />
        </Circle>
        <TextContainer>
          <Typography variant="h6" align="center">
            {t('thank-you-for-your-feedback')}
          </Typography>
        </TextContainer>
      </Content>
    </Fade>
  )
}

export default RequestForProposalFeedbackSuccessState
